<template>
  <span></span>
</template>

<script>
/* eslint-disable semi */
import { Component, Prop } from 'vue-property-decorator';
import AppComponent from '@/app/AppComponent';
import _ from 'lodash';

/**
 * スクロールスパイ
 * スクロールイベントが発生した場合下記のイベントを$emitします
 * イベント名  app-event
 * パラメータ1 name
 * パラメータ2 位置情報
 */
@Component
export default class AppSpacer extends AppComponent {
  @Prop({ required: false })
  name;

  get listener () {
    if (this._listener === undefined) {
      this._listener = e => {
        this.onScroll(e);
      }
    }
    return this._listener;
  }

  mounted () {
    window.addEventListener('scroll', _.throttle(this.listener, 100));
  }
  destroyed () {
    window.removeEventListener('scroll', this.listener);
  }

  onScroll (e) {
    var clientRect = this.$el.getBoundingClientRect();
    this.$emit('app-event', 'scroll', this.name, clientRect);
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/AppScrollSpy.vue